import React from 'react';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { isFeatureEnabled } from 'ff/common/ffAppUtils';
import SegmentAnalytics from 'ff/debrief/SegmentAnalytics';

import { useDebriefModal } from 'ff/debrief/modalManager';

import Kebab from 'ff/debrief/components/menu/Kebab';
import DebriefButton from 'ff/debrief/components/DebriefButton';

interface Props {}

const ActionRow: React.FC<Props> = props => {
    const { open: openOtherInfoModal } = useDebriefModal('OtherInfo');

    const handleInfoClick = () => {
        openOtherInfoModal();
        SegmentAnalytics.logEvent('Debrief, Other Info Clicked');
    };

    return (
        <Stack direction="row" justifyContent="end" gap={1}>
            <Button onClick={handleInfoClick} variant="outlined">
                Details
            </Button>
            {isFeatureEnabled('debrief_features') && <DebriefButton />}
            <Kebab></Kebab>
        </Stack>
    );
};

export default ActionRow;
